import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trash2, BellDot } from "lucide-react";

export default function MisenFavoris({ fav, funk }) {
    return (
        <>
            <div className="row">
            {fav && fav
                .filter(f => f.lu !== true) // Filtrer les éléments où `lu` n'est pas vrai
                .map((f, index) => (
                    <div className="col-md-4" key={index}>
                        <div className="card mb-2">
                            <FavorisDetails data={f} refresh={funk} />
                        </div>
                    </div>
                ))
            }
        </div>
        </>
    );
}

function FavorisDetails({ data, refresh }) {
    const [user, setUser] = useState(null);
    const [cv, setCv] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [userResp, cvResp] = await Promise.all([
                    axios.get(`users/${data.user_id}`),
                    axios.get(`cvs?id=${data.cv_id}`)
                ]);
                if (userResp.status === 200) {
                    setUser(userResp.data.user);
                }
                if (cvResp.status === 200) {
                    setCv(cvResp.data);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [data.user_id, data.cv_id]);

    const daty = moment(data.created_at).format('Do MMMM YYYY, h:mm a'); // Ex: August 17th 2023, 12:39 pm

    const [isLu, setIsLu] = useState(data.lu);
    const handleClick = () => {
        if (!isLu) {
            axios.put(`favorites/${data.id}`, { lu: true})
            setIsLu(true);
        }
    }

    // const handleFavoriteNotif = () => {
    //     const formData = new FormData();
    //     formData.append('cv_id', cv.id);
    //     formData.append('user_id', user.id);

    //     axios.post('removefavorite', formData)
    //         .then(resp => {
    //             if (resp.status === 200) {
    //                 setIsFavorite(!isFavorite);
    //                 const message = isFavorite
    //                     ? 'Retiré avec succès de vos favoris.'
    //                     : 'Ajouté avec succès à vos favoris.';
    //                 NotificationManager.success(message, 'Valider', 4000);
    //             }
    //         })
    //         .catch(error => console.log(error));
    // };

    return (
        <div className="card-body">
            <h6 className="card-title">
                <b><span style={{color: "#263F8C"}}>{user?.name}</span> a mis <span className="text-info">{cv?.nomPrenom} ({cv?.id})</span> dans sa liste de favoris</b>
            </h6>
            <h6 className="card-subtitle mb-2 text-muted">
                {user?.email} / {user?.phone}
            </h6>

            <div>
            <span
                className={`badge ${isLu ? 'badge-success' : 'badge-secondary'}`}
                style={{ cursor: !isLu ? 'pointer' : 'default' }}
                onClick={handleClick}
            >
                {isLu ? <i className="bi bi-check2-all"></i> : <BellDot size={16} strokeWidth={2} />}
                {isLu ? ' lu' : ' non lu'}
            </span>
            </div>

            <p className="card-text">Le {daty}</p>
            <Link to={`/user/${user?.id}`} className="card-link"><button className="btn btn-dark btn-sm">A propos de {user?.name}</button></Link>
            <Link to={`/cv/${cv?.id}`} className="card-link"><button className="btn btn-info btn-sm">A propos de {cv?.nomPrenom}</button></Link>
            {/* <button className="btn btn-outline-danger btn-sm" onClick={handleFavoriteNotif}><Trash2 size={20} strokeWidth={1.5} /></button> */}
        </div>
    );
}
